<ion-header class="remove-margin-from-safe-area ion-no-border">
    <ion-toolbar>
        <ion-grid>
            <ion-row>
                <ion-col>
                    <ion-toolbar>
                        <ion-buttons slot="end">
                            <ion-button (click)="onCancelModal()"
                            >
                                <ion-icon color="dark" name="close"></ion-icon
                                >
                            </ion-button>
                        </ion-buttons>
                    </ion-toolbar>
                </ion-col>
            </ion-row>
            <ion-row>
                <ion-col style="text-align: center;">
                    <h2 class="subheader-regular">{{ violation['Ticket']}}</h2>
                </ion-col>
            </ion-row>
        </ion-grid>

    </ion-toolbar>
</ion-header>

<ion-content>

    <ion-grid class="single-col-wider">
        <form [formGroup]="appeal">
            <ion-row>
                <ion-col size="12">

                    <ion-grid>
                        <ion-row>
                            <ion-col>
                                <ion-item fill="outline">
                                    <ion-label position="floating">{{ ('keys.data.violations.reason_for_appeal' |
                                        translate : {Default: 'Reason for Appeal'}) || 'Reason for Appeal' }}:
                                    </ion-label>

                                    <ion-textarea
                                            rows="5"
                                            minlength="20"
                                            formControlName="reason"
                                            required
                                            #reason
                                    ></ion-textarea>
                                </ion-item>
                            </ion-col>
                        </ion-row>

                        <ion-row>
                            <ion-col size="12" style="text-align: center;">
                                <sub style="color: darkslategrey;">
                                    {{ ('keys.data.violations.appeal_error' | translate : {Default: 'label: The reason must be at least 20 characters.'}) || 'Note: The reason must be at least 20 characters.' }}
                                </sub>
                            </ion-col>
                        </ion-row>

                        <ion-row>
                            <ion-col>
                                <ng-container *ngIf="errors['error']">
                                    <ion-text
                                            rows="6"
                                            color="danger"
                                            *ngFor="let error of errors['error']['errors']['reason']"
                                    >{{ error }}
                                        <br/>
                                    </ion-text>
                                </ng-container>
                            </ion-col>
                        </ion-row>

                    </ion-grid>

                </ion-col>
            </ion-row>

            <ion-row *ngIf="dataService['settings']['violations']['enable_appeal_file_uploads'] == true">
                <ion-col class="single-col-wider">

                    <input hidden type="file" accept="image/*" #filepicker (change)="fileSelected($event)"/>

                    <ion-card>
                        <ion-card-content>
                            <ion-item (click)="selectFile()" lines="none" style="border: 1px dashed var(--Black-Pastel, #D2D2D2);text-align: center;cursor: pointer;">
                                <ion-icon name="cloud-upload"></ion-icon>
                                <ion-label class="ion-text-wrap"
                                >{{ ('keys.data.profile.select_files_to_upload' |
                                    translate : {Default: 'Select Files to upload'}) || 'Select Files to upload' }}</ion-label
                                >
                            </ion-item>

                            <ion-card *ngFor="let file of files; let i = index" class="card-shadow-3">
                                <ion-item lines="none" class="stacked-items">
                                    <ion-thumbnail slot="start">
                                        <ion-img *ngIf="file.type!='.pdf'" [src]="file.data"></ion-img>
                                        <ion-img *ngIf="file.type=='.pdf'" src="assets/images/document.svg "></ion-img>
                                    </ion-thumbnail>
                                    <ion-label class="ion-text-wrap">{{ file.name }}</ion-label>
                                    <ion-button (click)="removeFile(i)" slot="end" fill="clear">
                                        <ion-icon color="dark" name="close"></ion-icon>
                                    </ion-button>
                                </ion-item>

                                <ion-item lines="none" class="swiper-items">
                                    <ion-thumbnail slot="start">
                                        <ion-img *ngIf="file.type!='.pdf'" [src]="file.data"></ion-img>
                                        <ion-img *ngIf="file.type=='.pdf'" src="assets/images/document.svg "></ion-img>
                                    </ion-thumbnail>
                                    <ion-button (click)="removeFile(i)" slot="end" fill="clear">
                                        <ion-icon color="dark" name="close"></ion-icon>
                                    </ion-button>
                                </ion-item>
                            </ion-card>

                        </ion-card-content>
                    </ion-card>

                    <ion-row>
                        <ion-col size="12" style="text-align: center;">
                            <sub style="color: darkslategrey;">
                                {{ ('keys.data.violations.appeals_only_these_files' | translate : {Default: 'Only filetypes JPG, PNG, and PDF up to 12MB accepted.'}) || 'Only filetypes JPG, PNG, and PDF up to 12MB accepted.' }}
                            </sub>
                        </ion-col>
                    </ion-row>

                </ion-col>
            </ion-row>

            <ion-row>
                <ion-col size="12">
                    <ion-button
                            [disabled]="!appeal.valid"
                            color="primary"
                            expand="block"
                            (click)="onSubmitAppeal()"
                    >
                        {{ ('keys.data.violations.submit_appeal' |
                        translate : {Default: 'Submit Appeal'}) || 'Submit Appeal' }}
                    </ion-button>
                </ion-col>
            </ion-row>

        </form>
    </ion-grid>

</ion-content>
